// @ts-nocheck
import { openAuthModal, setAuthResetToken } from './auth-flow';

export function getResetTokenFromUrl(params?: URLSearchParams): string | null {
  const search = params ?? new URLSearchParams(window.location.search);
  const token = search.get('reset_token')?.trim();
  return token || null;
}

export function clearResetTokenFromUrl(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('reset_token')) return;
  url.searchParams.delete('reset_token');
  const next = url.pathname + (url.search ? url.search : '') + url.hash;
  window.history.replaceState({}, '', next);
}

export function initPasswordResetDeepLink(): void {
  const token = getResetTokenFromUrl();
  if (!token) return;
  setAuthResetToken(token);
  openAuthModal('reset');
}
